export default __webpack_public_path__ + "static/media/Classwin-LevelCourse-blue.2f3e232e.svg";